export default {
  path: 'tracking-history',
  name: 'TrackingHistory',
  component: () => import(/* webpackChunkName: "satellite-tracking" */ '../views/TrackingHistory.vue')
}
